export default __webpack_public_path__ + "static/ios-logo-1-d6f1742bfcfba080f57857e34de66ab6.webp";